var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h2',{staticClass:"sub-title"},[(_vm.episodeNumber)?[_vm._v(_vm._s(_vm.episodeNumber)+". ")]:_vm._e(),_vm._v("\n  "+_vm._s(_vm.episodeTitle || '에피소드')+"\n")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }